<template>
	<div class="date-popup-view">
		<month-view :value="date" @input="callback($event)" />
	</div>
</template>

<script>
	export default {
		name: 'select-popup-view',
		props: ['callback', 'date']
	}
</script>

<style lang="scss" scoped>
	.select-popup-view {
		& > .options {
			display: grid;
			row-gap: 1px;
			background-color: rgb(236, 236, 236);

			& > .option {
				background-color: white;

				& > .double {
					display: grid;
					grid-template-columns: 1fr 1fr;
					padding: 0 20px 0 20px;

					& > .value, & > .label {
						line-height: 48px;
					}

					& > .value {
						text-align: right;
					}
				}

				& > .single {
					padding: 0 20px 0 20px;
					line-height: 48px;
					text-align: center;
				}
			}
		}
	}
</style>